export const FALLBACK_EVENT_POSTERS = {
  music: "https://images.unsplash.com/photo-1501281668745-f7f57925c3b4?w=1200&q=80",
  comedy: "https://images.unsplash.com/photo-1527224857830-43a7acc85260?w=1200&q=80",
  festival: "https://images.unsplash.com/photo-1533174072545-7a4b6ad7a6c3?w=1200&q=80",
  festivals: "https://images.unsplash.com/photo-1533174072545-7a4b6ad7a6c3?w=1200&q=80",
  food: "https://images.unsplash.com/photo-1555939594-58d7cb561ad1?w=1200&q=80",
  spiritual: "https://images.unsplash.com/photo-1545389336-cf090694435e?w=1200&q=80",
  theatre: "https://images.unsplash.com/photo-1503095396549-807759245b35?w=1200&q=80",
  theater: "https://images.unsplash.com/photo-1503095396549-807759245b35?w=1200&q=80",
  sports: "https://images.unsplash.com/photo-1461896836934-ffe607ba8211?w=1200&q=80",
  business: "https://images.unsplash.com/photo-1515169067865-5387ec356754?w=1200&q=80",
  workshops: "https://images.unsplash.com/photo-1517048676732-d65bc937f952?w=1200&q=80",
  kids: "https://images.unsplash.com/photo-1503454537195-1dcabb73ffb9?w=1200&q=80",
  dance: "https://images.unsplash.com/photo-1535525153412-5a092d46bd13?w=1200&q=80",
  bollywood: "https://images.unsplash.com/photo-1485095329183-d0797cdc5676?w=1200&q=80",
  wellness: "https://images.unsplash.com/photo-1544367567-0f2fcb009e0b?w=1200&q=80",
  wedding: "https://images.unsplash.com/photo-1519741497674-611481863552?w=1200&q=80",
  networking: "https://images.unsplash.com/photo-1511795409834-ef04bbd61622?w=1200&q=80",
  art: "https://images.unsplash.com/photo-1513364776144-60967b0f800f?w=1200&q=80",
  books: "https://images.unsplash.com/photo-1519682337058-a94d519337bc?w=1200&q=80",
  photography: "https://images.unsplash.com/photo-1492691527719-9d1e07e534b4?w=1200&q=80",
  tech: "https://images.unsplash.com/photo-1518770660439-4636190af475?w=1200&q=80",
  movies: "https://images.unsplash.com/photo-1489599849927-2ee91cede3ba?w=1200&q=80",
  default: "https://images.unsplash.com/photo-1517457373958-b7bdd4587205?w=1200&q=80",
};

export function getEventId(event) {
  return event?.event_id || event?.id || event?._id || event?.eventbrite_id || "";
}

export function getEventPoster(event) {
  const posterUrl = typeof event?.poster_url === "string" ? event.poster_url.trim() : "";
  if (posterUrl) return posterUrl;
  const poster = typeof event?.poster === "string" ? event.poster.trim() : "";
  if (poster) return poster;
  const category = String(event?.category || "").trim().toLowerCase();
  return FALLBACK_EVENT_POSTERS[category] || FALLBACK_EVENT_POSTERS.default;
}

export function applyPosterFallback(errorEvent, event) {
  errorEvent.currentTarget.onerror = null;
  errorEvent.currentTarget.src = getEventPoster({ category: event?.category });
}
